// Sposta il blocco quantità+sconto e lo inserisce in fondo alle opzioni Customily quando il modal customily è aperto
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {
    // ID della collezione target
    const eligibleCollectionId = 667245511004;
    const product = window.product || {};

    const isEligible =
        Array.isArray(product.collections) &&
        product.collections.some((c) => c.id == eligibleCollectionId);

    if (!isEligible) return;

    let isInside = false;
    let placeholder = null;

    const observer = new MutationObserver(() => {
        const modalDesktop = document.querySelector(".customily-modal-container");
        const modalMobile = document.querySelector(".csh-product-customizer-modal");
        const quantityBlock = document.querySelector(".quantity-picker.inkybay_custom_product_hide_elements");
        const customilyOptions = document.querySelectorAll(".customily_option");

        if ((!modalDesktop && !modalMobile) || !quantityBlock) return;

        // visibilità modal (una delle due)
        const modalVisible =
            (modalDesktop && modalDesktop.style.display !== "none") ||
            (modalMobile && modalMobile.style.display !== "none");

        // trova ultima opzione Customily o contenuto interno
        const lastOption = customilyOptions[customilyOptions.length - 1];
        const content = lastOption?.querySelector(".cl-option-content") || lastOption;
        const spacer = content?.querySelector(".bottom-spacer") || content;

        // Modal aperto: sposta dentro Customily
        if (modalVisible && !isInside && customilyOptions.length && spacer) {
            if (!placeholder) {
                placeholder = document.createElement("div");
                placeholder.className = "quantity-placeholder";
                placeholder.style.minHeight = `${quantityBlock.offsetHeight}px`;
                quantityBlock.parentElement.insertBefore(placeholder, quantityBlock);
            }

            spacer.parentElement.insertBefore(quantityBlock, spacer);
            quantityBlock.style.marginTop = "20px";
            quantityBlock.style.marginBottom = "10px";
            isInside = true;
        }

        // Modal chiuso: ripristina posizione originale
        if (!modalVisible && isInside && placeholder) {
            placeholder.parentElement.insertBefore(quantityBlock, placeholder);
            placeholder.remove();
            placeholder = null;
            isInside = false;
        }

        const fakeLabel = document.querySelector(
            '.customily_option label[for*="cl-option-accordion"][aria-controls*="-4"]'
        );
        const fakeCheckbox = document.querySelector(
            '.customily_option .checkbox-container input[name="properties[Quantità]"]'
        );

        if (fakeLabel) {
            fakeLabel.style.display = "none";
        }

        if (fakeCheckbox) {
            const parentBox = fakeCheckbox.closest(".checkbox-container");
            if (parentBox) parentBox.style.display = "none";
        }
    });

    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
});
